import { CompositeLayer } from '@deck.gl/core';
import { IconLayer } from '@deck.gl/layers';

export const CRG_CALL_ICONS_LAYER = 'crg-call-icons-layer';

class CRGCallsLayer extends CompositeLayer {
  initializeState() {
    super.initializeState();
    this.state.isClicked = false;
  }

  onHover(info, pickingEvent) {
    // This bugfix suppressed the first hover after a click which causes
    // features like popovers to close immediately after a click.
    if (this.state.isClicked) {
      this.state.isClicked = false;
      return;
    }
    super.onHover(info, pickingEvent);
  }

  onClick(info, pickingEvent) {
    this.state.isClicked = true;
    super.onClick(info, pickingEvent);
  }

  renderLayers() {
    const { data, layerProps, onHover, onClick } = this.props;

    // Primary locations markers
    const primaryCallsIconLayer = new IconLayer(
      this.getSubLayerProps({
        id: CRG_CALL_ICONS_LAYER,
        data: data.primaryLocations,
        parameters: {
          depthTest: true,
        },
        onClick,
        onHover,
        ...layerProps,
      }),
    );

    return [primaryCallsIconLayer];
  }
}

CRGCallsLayer.layerName = 'CRGCallsLayer';
CRGCallsLayer.defaultProps = { visible: true, data: [] };

/**
 * This layer is the same as IconPolygonLayer, but the order of the layers is
 * reversed. This is used by the DeckOverlay to reverse layer order for map
 * providers that have different ordering conventions (like GMaps).
 */
export class CRGCallsLayerReversed extends CRGCallsLayer {
  renderLayers() {
    const layers = super.renderLayers();
    return layers.reverse();
  }
}

export default CRGCallsLayer;
